// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import resolutionStatusEntity from './entities/resolution-status.json';
import resolutionStatusMenu from '../pages/resolution-status/menu.json';
import resolutionStatusFullForm from '../pages/resolution-status/forms/full.json';
import resolutionStatusContextForm from '../pages/resolution-status/forms/context.json';
import resolutionStatusMiniForm from '../pages/resolution-status/forms/mini.json';
import resolutionStatusLookupForm from '../pages/resolution-status/forms/lookup.json';
import resolutionStatusTableView from '../pages/resolution-status/views/table.json';
import resolutionStatusDashboardView from '../pages/resolution-status/views/dashboard.json';

/** Тип запису «Статус постанови» зі сторінками пакета: меню, форми та подання з pages/resolution-status/. */
export const resolutionStatusDefinition: IRecordTypeDefinition = {
  ...resolutionStatusEntity,
  views: assembleViewSet({
      table: resolutionStatusTableView,
      dashboard: resolutionStatusDashboardView,
  }),
  form: resolutionStatusFullForm,
  forms: { full: resolutionStatusFullForm, context: resolutionStatusContextForm, mini: resolutionStatusMiniForm, lookup: resolutionStatusLookupForm },
  menu: resolutionStatusMenu,
} as IRecordTypeDefinition;
